import(/* webpackMode: "eager", webpackExports: ["BentoCard"] */ "/opt/buildhome/repo/apps/web/src/components/landing-page/components/bento-card.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/src/components/landing-page/components/link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogoCluster"] */ "/opt/buildhome/repo/apps/web/src/components/landing-page/components/logo-cluster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Logo"] */ "/opt/buildhome/repo/apps/web/src/components/landing-page/components/logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/opt/buildhome/repo/apps/web/src/components/landing-page/components/navbar.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@14.2.25_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
